/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string, oneOfType,
    number, bool, arrayOf,
} from 'prop-types';
import { connect,  useDispatch } from 'react-redux';

import CardLayout from '../../../common/CardLayout';
import RecipientDetails from './Modal/RecipientDetails';
import configENV from '../../../config';
import Spinner from '../../../assets/svg/Spinner';
import EventDispatcher from '../../../state/reducers/EventDispatcher';

const { PERSIST_KEY } = configENV;

const RecipientList = ({
    isFetchingModal,
    occasionId,
    recipientsByPage,
}) => {
    const singleRecipient = recipientsByPage.length === 1;
    const dispatch = useDispatch();

    if (!isFetchingModal) {
        return (
            <div className="spinner gift-list">
                <Spinner />
            </div>
        );
    }
    return (
        <>
            {!singleRecipient ? (
                <>
                    {recipientsByPage.map((recipient) => (
                        <CardLayout
                            customClass="margin-bottom-2x"
                            key={recipient.id}
                            recipient={recipient}
                            onClick={() => dispatch(EventDispatcher.handleGiftListRecipientClicked(recipient))}
                        />
                    ))}
                    <CardLayout
                        customClass="margin-bottom-2x"
                        recipient={{
                            id: 0,
                            name: 'Add New Recipient',
                            type: 'button',
                        }}
                        onClick={() => dispatch(EventDispatcher.handleGiftListAddNewRecipientClicked(occasionId))}
                    />
                </>
            ) : (
                <>
                    <RecipientDetails
                        recipient={recipientsByPage[0]}
                        isInsideModal="false"
                    />
                    <CardLayout
                        customClass="margin-bottom-2x"
                        recipient={{
                            id: 0,
                            name: 'Add New Recipient',
                            type: 'button',
                        }}
                        onClick={() => dispatch(EventDispatcher.handleGiftListAddNewRecipientClicked(occasionId))}
                    />
                </>
            )}
        </>
    );
};

RecipientList.propTypes = {
    isFetchingModal: bool.isRequired,
    occasionId: string.isRequired,
    recipientsByPage: arrayOf(
        shape({
            AddressBookEntryId: string,
            addToCart: string,
            address: shape({
                addressId: string,
                apt: string,
                city: string,
                company: string,
                country: shape({
                    id: string,
                    name: string,
                }),
                location: shape({
                    id: number,
                    name: string,
                }),
                state: shape({
                    id: string,
                    name: string,
                }),
                street: string,
                zipcode: string,
            }),
            addressId: string,
            firstname: string,
            giftArrived: string,
            id: string,
            isNewRecipient: bool,
            lastname: string,
            occasionId: string,
            orderItemId: string,
            products: arrayOf(
                shape({
                    content: string,
                    crossedPrice: oneOfType([number, string]),
                    discountPrice: oneOfType([number, string]),
                    id: string,
                    image: string,
                    name: string,
                    parentCatalogEntryId: string,
                    partNumber: string,
                    price: number,
                    seoproductDisplayURL: string,
                    sku: string,
                    status: string,
                }),
            ),
            type: string,
        }),
    ).isRequired,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isFetchingModal: newState.isReadyState,
        pageData: newState.pageData,
        orderId: newState.giftList.orderId,
        occasionId: newState.giftList.occasionId,
        occasions: newState.giftList.occasions,
        recipients: newState.giftList.recipients,
        recipientsByPage: newState.giftList.recipientsByPage,
    };
};

export default connect(
    mapStateToProps,
    null,
)(RecipientList);
